import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import { App } from './App';
import './index.scss';
import store from './redux/store/store';
import reportWebVitals from './reportWebVitals';

const setAppHeight = () => {
  document.documentElement.style.setProperty(
    '--app-height',
    `${window.innerHeight}px`
  );
};

const RESIZE_OBSERVER_MESSAGES = new Set([
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
]);

window.addEventListener('error', (event) => {
  if (RESIZE_OBSERVER_MESSAGES.has(event.message)) {
    event.stopImmediatePropagation();
  }
});

window.addEventListener('resize', setAppHeight);
window.addEventListener('orientationchange', setAppHeight);
setAppHeight();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <div className="main">
      <BrowserRouter>
        <Provider store={store}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Toaster
              position="bottom-right"
              toastOptions={{ duration: 5500 }}
              containerStyle={{ zIndex: 999999 }}
            />
            <App />
          </LocalizationProvider>
        </Provider>
      </BrowserRouter>
    </div>
  </React.StrictMode>
);

reportWebVitals();
